<script lang="ts" setup>
import GenderBadge from "@/components/MateStyle/GenderBadge.vue";
import UserAvatar from "@/components/UserAvatar.vue";
import { useMateTypeText } from "@/use/common";
import { Gender, MateType } from "@/types/entity";
import { ref } from "vue";

// props & emit
export interface SocialListItem {
  id: number;
  mateId: number;
  avatarUrl: string;
  gender: Gender;
  name: string;
  type: MateType;
  isFollowing?: boolean;
  content?: string;
  followClick?: () => Promise<any>;
}

const props = withDefaults(defineProps<SocialListItem>(), {
  isFollowing: false,
});

const btnLoading = ref(false);
// 内部状态
const mateType = useMateTypeText(props.type);
// Event Handler
const onFollowBtnClick = async (e: Event) => {
  e.stopPropagation();
  btnLoading.value = true;
  try {
    await props.followClick?.();
  } finally {
    btnLoading.value = false;
  }
};
</script>
<template>
  <div class="flex p-2 border-b gap-2 max-h-32">
    <user-avatar :avatar-url="avatarUrl" class="h-[5.5rem] shrink-0 mr-2" />
    <div class="flex flex-col flex-grow gap-2">
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <div class="font-bold">{{ name }}</div>
            <gender-badge :gender="gender" class="w-5" />
          </div>
          <div class="text-xs text-base-content/50">{{ mateType }}</div>
        </div>
        <slot>
          <button
            :disabled="btnLoading"
            class="btn btn-xs self-stretch rounded"
            @click="onFollowBtnClick"
          >
            <span v-if="btnLoading" class="loading loading-xs"></span>
            {{
              isFollowing ? $t("User.mate.following") : $t("User.mate.follow")
            }}
          </button>
        </slot>
      </div>
      <div class="line-clamp-3 text-xs text-base-content/50">
        {{ content ? content : $t("Texts.noIntroductionText") }}
      </div>
    </div>
  </div>
</template>
